import React, { useState, useRef } from "react";

import { Styles } from "./becomeEmployer";
import { colors } from "../../../utils/Colors";
import Error from "../../../components/common/Error";
import Header from "../../../components/common/Header";
import Footer from "../../../components/common/Footer";
import AddProfile from "../../../assets/icons/addProfile.png";

import { BecomeEmployerSchema } from "../../../utils/PostJobSchema";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../features/authentication";
import { useFormik } from "formik";
import Button from "../../../components/common/Button";
import InputField from "../../../components/common/InputField";

const BecomeEmployer = () => {
  const [image, setImage] = useState(null);
  const fileRef = useRef(null);
  const { becomeEmployer, user } = useAuthContext();
  const navigate = useNavigate();

  const username = user?.username;
  const email = user?.email;

  const initialValues = {
    description: "",
    companyName: "",
    profileImg: null,
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    isSubmitting,
  } = useFormik({
    initialValues,
    validationSchema: BecomeEmployerSchema,
    onSubmit: async (values, action) => {
      await becomeEmployer(values);
      updateAuth();
      navigate("/");
    },
  });

  const updateAuth = async () => {
    const auth = JSON.parse(localStorage.getItem("auth"));
    auth.isEmployer = true;
    localStorage.setItem("auth", JSON.stringify(auth));
    return auth;
  };

  return (
    <>
      <Header />
      <Styles colors={colors}>
        <div className="become-seller-page">
          <form onSubmit={handleSubmit}>
            <h3 className="mb-3">
              <span className="falcon-clr">Employer</span> Profile
            </h3>
            <div className="d-flex flex-column flex-sm-row flex-wrap gap-3 w-100">
              <div className="become-wrapper" style={{ flex: "3" }}>
                <h5 className="heading mb-3">
                  <span className="falcon-clr heading ">Personal</span>{" "}
                  Information
                </h5>
                <div>
                  <div className="mb-3">
                    <p className="light font-small grey-clr mb-1">Username</p>
                    <p className="font-large username pb-1">{username}</p>
                  </div>
                  <div>
                    <p className="light font-small grey-clr mb-1">Email</p>
                    <p className="font-large username pb-1">{email}</p>
                  </div>
                </div>
              </div>
              <div className="become-wrapper" style={{ flex: "2" }}>
                <h5 className="heading mb-3">
                  <span className="falcon-clr heading ">Company/Business</span> Image or Logo
                </h5>
                <div className="d-flex align-items-center">
                  <input
                    hidden
                    ref={fileRef}
                    accept="image/*"
                    type="file"
                    onChange={(e) => {
                      if (e.target.files[0]) {
                        setImage(e.target.files[0]);
                        setFieldValue("profileImg", e.target.files[0]);
                      } else {
                        setImage(null);
                        setFieldValue("profileImg", null);
                      }
                    }}
                  />
                  {image ? (
                    <img
                      className="profile-pic-wrapper d-flex align-items-center justify-content-center"
                      src={URL.createObjectURL(image)}
                      alt="Preview"
                      width="120"
                      height="120"
                      style={{ objectFit: "cover", cursor: "pointer" }}
                      onClick={() => {
                        fileRef.current.click();
                      }}
                      onBlur={handleBlur}
                    />
                  ) : (
                    <div
                      className="profile-pic-wrapper d-flex align-items-center justify-content-center"
                      onClick={() => {
                        fileRef.current.click();
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        className="add-profile-pic"
                        src={AddProfile}
                        alt={"profilePic"}
                      />
                    </div>
                  )}
                </div>
                <div style={{ height: "20px" }}>
                  {errors.profileImg && touched.profileImg && (
                    <Error text={errors.profileImg} />
                  )}
                </div>
              </div>
            </div>
            <div className="mt-3">
              <InputField
                className="setting-input mb-2"
                name="companyName"
                label="Company/Business Name"
                placeholder="Company/Business Name"
                value={values.companyName}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.companyName && touched.companyName && (
                <Error text={errors.companyName} />
              )}
            </div>
            <div className="become-wrapper mt-3">
              <h5 className="heading">Company/Business Details</h5>
              <textarea
                id="description"
                name="description"
                placeholder="Write about your Company/Business Details ..."
                onChange={handleChange}
                value={values.description}
                onBlur={handleBlur}
              ></textarea>
              <div className="d-flex justify-content-between align-items-center">
                <div style={{ height: "20px" }}>
                  {errors.description && touched.description && (
                    <Error text={errors.description} />
                  )}
                </div>
                <p className="heading font-small">
                  {values.description.length} /600
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <Button
                children={
                  isSubmitting ? (
                    <div
                      className="spinner-border spinner-border-sm and spinner-grow-sm mb-0"
                      role="status"
                    >
                      <span className="sr-only"></span>
                    </div>
                  ) : (
                    "Submit"
                  )
                }
                type="submit"
                disabled={isSubmitting}
                className="accept-btn complete-btn"
              />
            </div>
          </form>
        </div>
      </Styles>
      <Footer />
    </>
  );
};

export default BecomeEmployer;
